class Money {
    static formatMoney (pence, format) {
        if (typeof pence === 'string') { pence = pence.replace('.', '') }
        let value = ''
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
        let formatString = (format || this.money_format)

        function defaultOption (opt, def) {
            return (typeof opt === 'undefined' ? def : opt)
        }

        function formatWithDelimiters (number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2)
            thousands = defaultOption(thousands, ',')
            decimal = defaultOption(decimal, '.')

            if (isNaN(number) || number == null) { return 0 }

            number = (number / 100.0).toFixed(precision)

            let parts = number.split('.')
            let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
            let pence = parts[1] ? (decimal + parts[1]) : ''

            return dollars + pence
        }

        switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(pence, 2)
            break
        case 'amount_no_decimals':
            value = formatWithDelimiters(pence, 0)
            break
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(pence, 2, '.', ',')
            break
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(pence, 0, '.', ',')
            break
        }

        return formatString.replace(placeholderRegex, value).replace('.00', '')
    }
}

export default Money



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/Money.js